import { type Audience, INTERNAL_JSD_LAND, INTERNAL_JSD_EXPAND } from './services/types.tsx';

export const PACKAGE_NAME = 'jiraJsdFirstImpressionsServices';

export const TEAM_NAME = 'jsd-shield';

export const KEY_DISMISSED = 'jsd-first-impressions-checklist.dismissed';

export const KEY_OPEN = 'jsd-first-impressions-checklist.open';

export const KEY_OPEN_TASK = 'jsd-first-impressions-checklist.open-task';

export const KEY_VERSION = 'jsd-first-impressions-checklist.version';

export const KEY_AUDIENCE = 'jsd-first-impressions-checklist.audience';

export const KEY_DEMO_PROJECT_ID = 'jsd-first-impressions-checklist.demo-project.id';

export const KEY_OTHER_PROJECT_NAME = 'jsd-first-impressions-checklist.other-project.name';
export const KEY_OTHER_PROJECT_KEY = 'jsd-first-impressions-checklist.other-project.key';
export const KEY_OTHER_PROJECT_IS_NEXT_GEN =
	'jsd-first-impressions-checklist.other-project.next-gen';

export const DEMO_SERVICE_PROJECT_NAME = 'Demo service project';

export type TaskId = string;

const getTaskCompletedKey = (taskId: TaskId) =>
	`jsd-first-impressions-checklist.completed.${taskId}`;

export const ASSIGN_THE_REQUEST = getTaskCompletedKey('ASSIGN_THE_REQUEST');
export const ADD_A_COMMENT = getTaskCompletedKey('ADD_A_COMMENT');
export const RESOLVE_THE_REQUEST = getTaskCompletedKey('RESOLVE_THE_REQUEST');
export const ASSIGN_THE_REQUEST_V2 = getTaskCompletedKey('ASSIGN_THE_REQUEST_V2');
export const ADD_A_COMMENT_V2 = getTaskCompletedKey('ADD_A_COMMENT_V2');
export const RESOLVE_THE_REQUEST_V2 = getTaskCompletedKey('RESOLVE_THE_REQUEST_V2');
export const CREATE_THE_REQUEST = getTaskCompletedKey('CREATE_THE_REQUEST');
export const INVITE_YOUR_TEAM = getTaskCompletedKey('INVITE_YOUR_TEAM');
export const LINK_TO_JIRA_SW_ISSUE = getTaskCompletedKey('LINK_TO_JIRA_SW_ISSUE');

export const CREATE_SERVICE_DESK = getTaskCompletedKey('CREATE_SERVICE_DESK');

export const TASKS_COMPLETED_KEYS: TaskId[] = [
	ASSIGN_THE_REQUEST,
	ADD_A_COMMENT,
	RESOLVE_THE_REQUEST,
	ASSIGN_THE_REQUEST_V2,
	ADD_A_COMMENT_V2,
	RESOLVE_THE_REQUEST_V2,
	CREATE_THE_REQUEST,
	INVITE_YOUR_TEAM,
	CREATE_SERVICE_DESK,
	LINK_TO_JIRA_SW_ISSUE,
];

export const TASK_ID_MAP: Record<TaskId, boolean> = TASKS_COMPLETED_KEYS.reduce<
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, any>
>((acc, k) => {
	acc[k] = true;
	return acc;
}, {});

export const DEFAULT_VERSION = 1;
export const JSD_LAND_AUDIENCE: Audience = INTERNAL_JSD_LAND;
export const JSD_JSW_EXPAND_AUDIENCE: Audience = INTERNAL_JSD_EXPAND;
export const DEFAULT_JSD_AUDIENCE: Audience = JSD_LAND_AUDIENCE;
